import React, { AnchorHTMLAttributes } from "react";
import { StyledLink } from "./Link.styled";
import { IconManager } from "../IconManager/IconManager";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { BodyTyp } from "../../Typography/Typography";

export enum LinkSizeEnum {
  XSMALL = "xsmall",
  SMALL = "small",
  REGULAR = "regular",
}

interface StyledLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode | string;
  onClick?: () => void;
  underline?: boolean;
  icon?: React.ReactNode;
  color?: string;
  size?: LinkSizeEnum;
  disabled?: boolean;
  useFillIcon?: boolean;
}

export const Link = ({
  children,
  onClick,
  underline,
  icon,
  color,
  size = LinkSizeEnum.REGULAR,
  disabled,
  useFillIcon,
  ...props
}: StyledLinkProps) => {
  return (
    <StyledLink
      onClick={disabled ? () => null : onClick}
      $underline={underline}
      $color={color}
      $disabled={disabled}
      $useFillIcon={useFillIcon}
      data-testid="link-test"
      {...props}
    >
      {icon && (
        <IconManager
          size={
            size === LinkSizeEnum.XSMALL
              ? IconSizeEnum.XSMALL
              : IconSizeEnum.SMALL
          }
          color={color}
          marginRight={size === LinkSizeEnum.REGULAR ? 10 : 7}
          {...(!disabled && {
            onClick: onClick,
          })}
        >
          {icon}
        </IconManager>
      )}
      {typeof children === "string" ? (
        <BodyTyp
          variant={
            size === LinkSizeEnum.REGULAR
              ? "1"
              : size === LinkSizeEnum.SMALL
                ? "2"
                : "3"
          }
          fontWeight={FontWeightEnum.MEDIUM}
          color={color}
        >
          {children}
        </BodyTyp>
      ) : (
        children
      )}
    </StyledLink>
  );
};
